/* MCW YouTube videos — click-to-play facade + library filter / "show more".
   Loaded (deferred) by sections/mcw-video-library.liquid and sections/mcw-video-strip.liquid.
   The YouTube iframe only loads after a click: no third-party requests and no layout cost before that.
   Plays use youtube-nocookie.com; they still count as views/watch time on the channel. */
(function () {
  if (window.__mcwVideos) return;
  window.__mcwVideos = true;

  function track(name, props) {
    try { if (typeof window.plausible === 'function') window.plausible(name, { props: props }); } catch (e) {}
  }

  // ---- click-to-play (event delegation, works for cards added later) ----
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.mcwv-fac');
    if (!btn) return;
    ev.preventDefault();
    var id = btn.getAttribute('data-yt');
    if (!/^[\w-]{11}$/.test(id || '')) return;
    var ifr = document.createElement('iframe');
    ifr.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    ifr.title = btn.getAttribute('aria-label') || 'YouTube video';
    ifr.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    ifr.setAttribute('allowfullscreen', '');
    ifr.loading = 'eager';
    btn.parentNode.replaceChild(ifr, btn);
    track('VideoPlay', { video: id, place: btn.getAttribute('data-place') || 'video', page: location.pathname });
  });

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[data-mcwv-out]');
    if (a) track('YouTubeClick', { spot: a.getAttribute('data-mcwv-out'), page: location.pathname });
  });

  // ---- library: topic chips + progressive "show more" ----
  function initLibrary(root) {
    if (root.dataset.mcwvInit) return;
    root.dataset.mcwvInit = '1';
    var per = parseInt(root.getAttribute('data-per'), 10) || 20;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mcwv-item]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-mcwv-chip]'));
    var more = root.querySelector('[data-mcwv-more]');
    var moreBtn = root.querySelector('[data-mcwv-more-btn]');
    var counter = root.querySelector('[data-mcwv-counter]');
    var status = root.querySelector('[data-mcwv-status]');
    var topic = 'all';
    var shown = per;

    function matches(li) {
      return topic === 'all' || (' ' + li.getAttribute('data-topics') + ' ').indexOf(' ' + topic + ' ') > -1;
    }
    function render() {
      var total = 0, visible = 0;
      items.forEach(function (li) {
        if (matches(li)) {
          total++;
          var show = total <= shown;
          li.hidden = !show;
          if (show) visible++;
        } else {
          li.hidden = true;
        }
      });
      if (counter) counter.textContent = 'Showing ' + visible + ' of ' + total + ' videos';
      if (more) more.hidden = visible >= total;
      return { total: total, visible: visible };
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        topic = chip.getAttribute('data-mcwv-chip');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        shown = per;
        var r = render();
        if (status) status.textContent = r.total + ' videos';
        track('VideoFilter', { topic: topic });
      });
    });
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var firstNew = null, count = 0;
        shown += per;
        items.forEach(function (li) { if (matches(li)) { count++; if (count === shown - per + 1) firstNew = li; } });
        render();
        if (firstNew) { var f = firstNew.querySelector('.mcwv-fac, iframe'); if (f) f.focus({ preventScroll: true }); }
      });
    }
    render();
  }

  function boot() {
    document.querySelectorAll('[data-mcwv-lib]').forEach(initLibrary);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
